// extracted by mini-css-extract-plugin
export default {"spinner":"spinner__1smbl","spinner_centered":"spinner_centered__hikDt"};